import { reduxForm } from 'redux-form';

import OwnerForm from './OwnerForm';

export default reduxForm({ form: 'ownerForm' })(OwnerForm);
